import mqBreakpoints from 'rp-mq-breakpoints';

/**
 * @ngdoc service
 * @name CommonUtils.CommonFunctions
 * @description
 * # CommonFunctions
 */
export default function ($rootScope) {
    'ngInject';

    const common = {};

    common.parseBreakpointsName = (name) => {
        switch (name) {
            case 'extra narrow':
                return 'extraNarrow';
            case 'extra wide':
                return 'extraWide';
            default:
                return name;
        }
    };

    // TODO: Implement function that raises event when breakpoint was changed
    common.getScreenSize = (breakpointName) => {
        const breakpointCode = breakpointName || mqBreakpoints.current().name;
        return common.parseBreakpointsName(breakpointCode);
    };

    /**
     * Get values for positioning block relatively to the element
     *
     * @param {object} element DOM element
     * @param {object} positionedElementRect rects of a DOM element that is being positioned
     * @param {string} bp current breakpoint
     */
    common.getOffsetRect = (element, positionedElementRect, bp) => {
        const box = element.getBoundingClientRect();
        const body = $(document).context.body;
        const docElem = $(document).context.documentElement;
        const scrollTop = $(window).pageYOffset || docElem.scrollTop || body.scrollTop;
        const scrollLeft = $(window).pageXOffset || docElem.scrollLeft || body.scrollLeft;
        const clientTop = docElem.clientTop || body.clientTop || 0;
        const clientLeft = docElem.clientLeft || body.clientLeft || 0;
        const top = Math.round(box.top + scrollTop - clientTop + box.height);
        let left = box.left + scrollLeft - clientLeft + (box.width / 2);

        if (left > positionedElementRect.width) {
            left -= (bp === 'medium') ? positionedElementRect.width :
            positionedElementRect.width / 2;
            left = Math.round(left);
        } else {
            left = '';
        }

        return { top, left };
    };

    $(window).on('rpBreakpointsSwitch', (e) => {
        $rootScope.$broadcast('breakpointChanged', common.getScreenSize(e.detail.breakpoint.name));
    });

    common.removeExistedSelector = (element, selector) => {
        if (element.hasClass(selector)) {
            element.removeClass(selector);
        }
    };

    return common;
}



// WEBPACK FOOTER //
// ./src/js/services/commonFunctions.js